module.exports = __webpack_public_path__ + "img/15.dc268e0d.png";